class RavingRoomCursor extends HTMLElement {
  connectedCallback() {
    this.pointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    this.onPointerCapabilityChange = this.updatePointerCapability.bind(this);
    this.onPointerMove = this.move.bind(this);
    this.onPointerLeave = this.hide.bind(this);

    this.pointerQuery.addEventListener('change', this.onPointerCapabilityChange);
    this.updatePointerCapability();
  }

  disconnectedCallback() {
    this.pointerQuery?.removeEventListener('change', this.onPointerCapabilityChange);
    this.disable();
  }

  updatePointerCapability() {
    if (this.pointerQuery.matches) {
      this.enable();
    } else {
      this.disable();
    }
  }

  enable() {
    document.documentElement.classList.add('rr-custom-cursor-enabled');
    window.addEventListener('pointermove', this.onPointerMove, { passive: true });
    document.documentElement.addEventListener('mouseleave', this.onPointerLeave);
  }

  disable() {
    document.documentElement.classList.remove('rr-custom-cursor-enabled');
    window.removeEventListener('pointermove', this.onPointerMove);
    document.documentElement.removeEventListener('mouseleave', this.onPointerLeave);
    this.hide();
  }

  move(event) {
    this.style.setProperty('--rr-cursor-x', `${event.clientX}px`);
    this.style.setProperty('--rr-cursor-y', `${event.clientY}px`);
    this.classList.add('is-visible');
  }

  hide() {
    this.classList.remove('is-visible');
  }
}

if (!customElements.get('raving-room-cursor')) {
  customElements.define('raving-room-cursor', RavingRoomCursor);
}
